import { useI18n } from '../../contexts/I18nContext';
import type { LeaveType } from '../../lib/leaveApi';
import { LEAVE_TYPE_COLOR } from '../../lib/leaveConstants';
import { statusBadgeStyle } from '../tasks/taskConstants';

/** Same inline-style reasoning as `LeaveStatusBadge`. */
export function LeaveTypeBadge({ type }: { type: LeaveType }) {
  const { t } = useI18n();
  return (
    <span className="ui-badge whitespace-nowrap" style={statusBadgeStyle(LEAVE_TYPE_COLOR[type])}>
      {t(`leave.type.${type}`)}
    </span>
  );
}
